import styled from "styled-components";
import { media } from "../../../../../components/common/media";

const CheckoutContainer = styled.section`
  .checkout {
    width: 100%;
    margin: 0 auto;
    padding: 80px 30px 50px 100px;
    display: flex;
    background: #fff;
    a {
      text-decoration: underline !important;
    }
    ${media.desktop`
      padding: 80px 30px 50px !important;
      margin-left: 0!important;
      display: block;
    `}
    ${media.tablet`
      padding: 80px 50px 50px !important;
    `}
    .place-inquiry {
      ${media.desktop`
        text-align: center;
      `}
    }
    .inquiry-button {
      background: #1ebec8;
      color: #fff;
      margin-top: 30px;
      width: 180px;
      border-radius: 0;
      text-transform: uppercase;
      height: 45px;
      font-weight: 400;
      ${media.desktop`
        width: 100%;
        max-width: 300px;
      `}
    }
    .inquiry-form-container {
      width: 100%;
      max-width: 650px;
      margin-top: -50px;
      ${media.desktop`
        margin: 50px auto;
      `}
      .fixed-width {
        width: 100%;
        max-width: 410px;
        ${media.desktop`
          max-width: 650px;
        `}
      }
      h2 {
        color: #000;
        font-weight: 700;
      }
      p {
        width: 100%;
        &.required {
          color: ${(props) => props.theme.colors.primary.main}
          font-size: 12px;
          margin-bottom: 5px;
          ${media.desktop`
            margin-bottom: 40px;
          `}
        }
      }
      .flex {
        display: flex;
        .country {
          margin-left: 20px;
        }
      }
      .MuiFormControl-root {
        width: 100%;
        margin-bottom: 15px;
      }
      .inquiry-phone {
        position: relative;
        img {
          opacity: 0.7;
          right: -40px;
          top: 20px;
          position: absolute;
          width: 20px;
          cursor: pointer;
          ${media.desktop`
            display: none;
          `}
          &:hover {
            opacity: 1;
            filter: invert(45%) sepia(87%) saturate(3254%) hue-rotate(339deg) brightness(96%)
              contrast(97%);
          }
        }
      }
      h6 {
        color: #000;
        text-transform: uppercase;
        font-weight: 700;
        position: absolute;
        left: -90px;
        top: 24px;
        font-size: 14px;
        ${media.desktop`
          left: 0;
          top: -25px;
        `}
      }
      .usage-info {
        position: relative;
        ${media.desktop`
          padding-top: 30px;
        `}
        h6 {
          top: 18px;
          left: -74px;
          ${media.desktop`
            left: 0;
            top: 10px;
          `}
        }
      }
      .inquiry-checkboxes {
        p {
          margin-top: 15px;
          font-size: 14px;
          span {
            font-weight: 700;
          }
        }
        input[type="checkbox"] {
          width: 0;
          height: 0;
          margin-right: 0;
        }
      }
    }
  }

  input[type="text"].error {
    border: 2px solid ${(props) => props.theme.colors.primary.main}
  }

  p.formError {
    margin-bottom: 15px;
    color: ${(props) => props.theme.colors.primary.main}
    font-weight: 400;
    font-size: 13px;
  }

  .cart-box {
    margin-top: 90px;
    width: 100%;
    height: 100%;
    max-width: 340px;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    position: relative;
    right: 120px;
    ${media.desktop`
      position: relative;
      right: 0;
      left: 50%;
      transform: translateX(-50%);
      margin-left: 0;
    `}
    .cart-item {
      position: relative;
      background: #fff;
      ${media.desktop`
        padding-bottom: 1px;
      `}
      .inquiry-img-container {
        position: relative;
        text-align: center;
        overflow: hidden;
        .inquiry-label {
          position: absolute;
          top: 15px;
          left: 15px;
          color: #fff;
          text-shadow: 1px 1px 1em rgba(0, 0, 0, 0.38);
          background: rgba(255, 255, 255, 0.4);
          border-radius: 3px;
          padding: 10px 15px;
          text-transform: uppercase;
          font-weight: 400;
          font-size: 13px;
          z-index: 3;
        }
        img {
          position: relative;
          z-index: 2;
          height: 200px;
          &.img-bg {
            position: absolute !important;
            width: 100%;
            left: 0;
            right: 0;
            filter: blur(1px);
            z-index: 1;
          }
        }
      }
      h5 {
        font-size: 16px;
        font-weight: 400;
        margin: 10px 10px 5px;
        a {
          color: #000;
          transition: all 0.6s ease 0s;
          &:hover {
            color: ${(props) => props.theme.colors.primary.main}
          }
        }
      }
      p {
        font-size: 14px;
        padding-left: 10px;
        color: #afafaf;
      }
      .clearance {
        position: absolute;
        right: 5px;
        bottom: -2px;
        ${media.desktop`
          bottom: 15px;
        `}
        div {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 5px;
          font-size: 11px;
          display: inline-block;
          text-align: center;
          color: #fff;
          line-height: 20px;
          vertical-align: middle;
          cursor: pointer;
          &.add-left {
            margin-left: 4px;
          }
          &.green {
            background-color: #8bc34a;
          }
          &.yellow {
            background-color: #ffc107;
          }
          &.red {
            background-color: #e14336;
          }
        }
      }
    }
  }
  .inewsletter-checkbox {
    ${media.desktop`
      display: none;
    `}
  }
  .MuiFormLabel-root.Mui-focused {
    color: #8593a0;
  }
  .MuiInput-underline::after,
  .MuiInput-underline:hover:not(.Mui-disabled)::before {
    border-bottom: 2px solid #8593a0;
  }
  .inquiry-intend {
    ${media.phone`
      font-size: 12px;
    `}
  }
`;

export default CheckoutContainer;
